export class NotificationsService {
  /**
   * @returns {Promise<any[]>}
   */
  static async list({ showOnlyNonRead = true } = {}) {
    try {
      const res = await brain.utils.ajaxMicroservice({
        method: 'GET',
        uri: `/v1/app/${brain.company.json.id}/list?showOnlyNonRead=${showOnlyNonRead}`,
        microservice: 'notifications',
      });

      return [null, res];
    } catch (err) {
      return [err, null];
    }
  }
}
